import { Outlet, useNavigate } from 'react-router-dom';
import React, { useEffect, useState } from 'react';
import { Skeleton, Tabs } from 'antd';

import { Page } from '../../../../../shared/ui/Page';
import { tabs } from '../utils/tabs';
import getEnvConfig from '../../../../../utils/config/env';
import { useAppSelector } from '../../../../../store';
import { selectShopCurrent } from '../../../../shops/features/shops/store/shopSlice';
import { useLazyReadAutoBroadcastQuery } from '../service/autoBroadcasts.api';

const pageSlug = 'crm-autobroadcast-page';

export const AutoBroadcastEdit = () => {
    const current = useAppSelector(selectShopCurrent);
    const navigate = useNavigate();

    const [tab, setTab] = useState(
        sessionStorage.getItem(pageSlug) || 'drop-cart'
    );
    const [getBroadcast, { isLoading }] = useLazyReadAutoBroadcastQuery();

    useEffect(() => {
        if (current) {
            getBroadcast(current.id);
        }
    }, [current]);

    useEffect(() => {
        sessionStorage.setItem(pageSlug, tab);
        navigate(
            `${getEnvConfig().PUBLIC_PATH}/crm/auto-broadcasts/${
                current.id
            }/settings/${tab}`
        );
    }, [tab]);

    return (
        <Page
            backRoute={'/app/crm/auto-broadcasts'}
            isBackButton
            title={'Триггерные сообщения'}
        >
            <Tabs activeKey={tab} onChange={setTab} items={tabs} />
            {isLoading ? <Skeleton /> : <Outlet />}
        </Page>
    );
};
